module.exports = __webpack_public_path__ + "img/congratulations-bg-layer.8a3f8bc2.png";